module.exports = __webpack_public_path__ + "assets/facebook-old.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/facebook-old.svg
// module id = 761
// module chunks = 0